import { FC } from 'react'
import { RouteObject, useLocation } from 'react-router-dom'
import { ArpDetails } from '../features/details-page'
import { Segment } from '../features/segment'


const SongDetailsPage: FC = () => (
  <Segment.ViewTracker attributes={{ path: '/song'}}>
    <ArpDetails />
  </Segment.ViewTracker>
)

export const SongDetailsRoute: RouteObject = {
  path: '/song',
  element: <SongDetailsPage />
}
